export default __webpack_public_path__ + "static/media/57.4b41b443.jpg";